import { render } from "./employee-module.vue?vue&type=template&id=5155025e"
import script from "./employee-module.vue?vue&type=script&lang=js"
export * from "./employee-module.vue?vue&type=script&lang=js"

import exportComponent from "/home/jenkins/workspace/DeputyApp_web-hr_202604021339/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__